"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BoardState_1 = require("./board/BoardState");
var GameVars = /** @class */ (function () {
    function GameVars() {
    }
    GameVars.getLocalStorageData = function (key) {
        var data = oMetaManager.localGetItem(key);
        return JSON.parse(data);
    };
    GameVars.setLocalStorageData = function (key, data) {
        oMetaManager.localSetItem(key, JSON.stringify(data));
    };
    GameVars.validName = function (name) {
        var i = name.indexOf(" ");
        if (i >= 0) {
            name = name.substr(0, i);
        }
        if (name.length > 13) {
            name = name.substr(0, 11);
            name += "...";
        }
        return name;
    };
    GameVars.showPilesCards = function () {
        console.log("DEAL PILE");
        for (var i = 0; i < BoardState_1.BoardState.currentInstance.board.dealPile.piledCards.length; i++) {
            console.log(BoardState_1.BoardState.currentInstance.board.dealPile.piledCards[i].cardValue.suit, BoardState_1.BoardState.currentInstance.board.dealPile.piledCards[i].cardValue.value);
        }
        console.log("DEAL PILE AUX");
        for (var i = 0; i < BoardState_1.BoardState.currentInstance.board.dealPile.piledCardsAux.length; i++) {
            console.log(BoardState_1.BoardState.currentInstance.board.dealPile.piledCardsAux[i].cardValue.suit, BoardState_1.BoardState.currentInstance.board.dealPile.piledCardsAux[i].cardValue.value);
        }
        for (var i = 0; i < BoardState_1.BoardState.currentInstance.board.piles.length; i++) {
            console.log("PILE " + i);
            for (var j = 0; j < BoardState_1.BoardState.currentInstance.board.piles[i].piledCards.length; j++) {
                console.log(BoardState_1.BoardState.currentInstance.board.piles[i].piledCards[j].cardValue.suit, BoardState_1.BoardState.currentInstance.board.piles[i].piledCards[j].cardValue.value);
            }
        }
    };
    GameVars.setGameMode = function () {
        var contestData = gamezop.getContestDetails();
        if (contestData && contestData.contestId) {
            GameVars.gzpGameMode = "tournament";
        }
        else if (gamezop.isBattleGame()) {
            GameVars.gzpGameMode = "battle";
        }
        else {
            GameVars.gzpGameMode = "casual";
        }
    };
    return GameVars;
}());
exports.GameVars = GameVars;
